const Footer = () => {
    return(
        <>
       <div className="footer">
       <div className="fitem">Contact Us</div>
       <div className="fitem">Terms & Conditions</div>
       <div className="fitem">Return Policy</div>
       <div className="fitem">Shipping Policy</div>
       </div>
        </>
    )
};

export default Footer;